import { v4 } from 'uuid'
import type { Branded } from '@/core/helperTypes'

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export type UUID = Branded<string, 'UUID'>

export const isUUID = (id: string): id is UUID => UUID_REGEX.test(id)

export const decodeUUID = (id: string): UUID => {
  if (!isUUID(id)) {
    throw new Error('Invalid UUID')
  }
  return id
}

export const encodeUUID = (id: UUID): string => id

export const createUUID = (): UUID => decodeUUID(v4())
